class CartDrawer extends HTMLElement{constructor(){super(),this.addEventListener("keyup",e=>"Escape"===e.code&&this.close()),this.querySelector("#CartDrawer-Overlay").addEventListener("click",this.close.bind(this)),this.setHeaderCartIconAccessibility()}setHeaderCartIconAccessibility(){let e=document.querySelector("#cart-icon-bubble");e.setAttribute("role","button"),e.setAttribute("aria-haspopup","dialog"),e.addEventListener("click",t=>{t.preventDefault(),this.open(e)}),e.addEventListener("keydown",t=>{"SPACE"===t.code.toUpperCase()&&(t.preventDefault(),this.open(e))})}open(e){e&&this.setActiveElement(e);let t=this.querySelector('[id^="Details-"] summary');t&&!t.hasAttribute("role")&&this.setSummaryAccessibility(t),setTimeout(()=>{this.classList.add("animate","active")}),this.addEventListener("transitionend",()=>{let e=this.classList.contains("is-empty")?this.querySelector(".drawer__inner-empty"):document.getElementById("CartDrawer"),t=this.querySelector(".drawer__inner")||this.querySelector(".drawer__close");trapFocus(e,t)},{once:!0}),document.body.classList.add("overflow-hidden")}close(){this.classList.remove("active"),removeTrapFocus(this.activeElement),document.body.classList.remove("overflow-hidden")}setSummaryAccessibility(e){e.setAttribute("role","button"),e.setAttribute("aria-expanded","false"),e.nextElementSibling.getAttribute("id")&&e.setAttribute("aria-controls",e.nextElementSibling.id),e.addEventListener("click",e=>{e.currentTarget.setAttribute("aria-expanded",!e.currentTarget.closest("details").hasAttribute("open"))}),e.parentElement.addEventListener("keyup",onKeyUpEscape)}renderContents(e){this.querySelector(".drawer__inner").classList.contains("is-empty")&&this.querySelector(".drawer__inner").classList.remove("is-empty"),this.productId=e.id,this.getSectionsToRender().forEach(t=>{let r=t.selector?document.querySelector(t.selector):document.getElementById(t.id);r.innerHTML=this.getSectionInnerHTML(e.sections[t.id],t.selector)}),setTimeout(()=>{this.querySelector("#CartDrawer-Overlay").addEventListener("click",this.close.bind(this)),this.open()})}getSectionInnerHTML(e,t=".shopify-section"){return new DOMParser().parseFromString(e,"text/html").querySelector(t).innerHTML}getSectionsToRender(){return[{id:"cart-drawer",selector:"#CartDrawer"},{id:"cart-icon-bubble"}]}getSectionDOM(e,t=".shopify-section"){return new DOMParser().parseFromString(e,"text/html").querySelector(t)}setActiveElement(e){this.activeElement=e}}customElements.define("cart-drawer",CartDrawer);class CartDrawerItems extends CartItems{getSectionsToRender(){return[{id:"CartDrawer",section:"cart-drawer",selector:".drawer__inner"},{id:"cart-icon-bubble",section:"cart-icon-bubble",selector:".shopify-section"}]}}customElements.define("cart-drawer-items",CartDrawerItems);

/* 1001 Perles — progression dynamique vers la livraison gratuite */
(function(){
  var threshold = 50;
  var scheduled = false;

  function parseMoney(text){
    if(!text) return NaN;
    var cleaned = String(text).replace(/\s/g,'').replace(/[^0-9,.-]/g,'');
    if(cleaned.indexOf(',') !== -1 && cleaned.indexOf('.') !== -1){
      if(cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) cleaned = cleaned.replace(/\./g,'').replace(',','.');
      else cleaned = cleaned.replace(/,/g,'');
    } else if(cleaned.indexOf(',') !== -1){
      cleaned = cleaned.replace(',','.');
    }
    return parseFloat(cleaned);
  }

  function formatCad(value){
    var rounded = Math.max(0,value);
    return rounded.toLocaleString('fr-CA',{minimumFractionDigits: rounded % 1 ? 2 : 0, maximumFractionDigits:2}) + ' $';
  }

  function updateFreeShipping(){
    scheduled = false;
    var drawer = document.querySelector('.cart-drawer');
    if(!drawer) return;
    var subtotalEl = drawer.querySelector('.totals__subtotal-value');
    var messageEl = drawer.querySelector('.shipping-savings-message');
    var barEl = drawer.querySelector('.free_inner_slider');
    var iconEl = drawer.querySelector('.free_inner_slider_icon');
    if(!subtotalEl || !messageEl) return;

    var subtotal = parseMoney(subtotalEl.textContent);
    if(!isFinite(subtotal)) return;
    var remaining = Math.max(0, threshold - subtotal);
    var percent = Math.max(0, Math.min(100, (subtotal / threshold) * 100));

    var message = subtotal >= threshold
      ? 'Livraison gratuite débloquée !'
      : 'Plus que ' + formatCad(remaining) + ' pour profiter de la livraison gratuite !';

    if(messageEl.textContent.trim() !== message) messageEl.textContent = message;
    messageEl.classList.toggle('is-unlocked', subtotal >= threshold);

    if(barEl) barEl.style.width = percent + '%';
    if(iconEl){
      if(percent <= 0) iconEl.style.left = '2px';
      else if(percent >= 100) iconEl.style.left = 'calc(100% - 24px)';
      else iconEl.style.left = percent + '%';
    }
  }

  function scheduleUpdate(){
    if(scheduled) return;
    scheduled = true;
    requestAnimationFrame(updateFreeShipping);
  }

  function start(){
    scheduleUpdate();
    var root = document.querySelector('cart-drawer') || document.body;
    new MutationObserver(scheduleUpdate).observe(root,{childList:true,subtree:true});
    document.addEventListener('change',function(e){if(e.target && e.target.closest && e.target.closest('cart-drawer')) setTimeout(scheduleUpdate,50);});
    document.addEventListener('click',function(e){if(e.target && e.target.closest && e.target.closest('cart-drawer .quantity__button, cart-drawer cart-remove-button')) setTimeout(scheduleUpdate,350);});
  }

  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start);
  else start();
})();
